import React from 'react';
import { HiOutlineCheckCircle, HiOutlineXCircle, HiOutlineDocumentCheck } from 'react-icons/hi2';

const Step6_PlantHeadApproval = ({ incidentData, readOnly = false }) => {
  if (!incidentData) return null;

  const isApproved = incidentData.currentStep > 6;

  return (
    <div className="bg-card p-6 rounded-xl border border-gray-200 shadow-sm max-w-4xl mx-auto my-0">
      <div className="border-b border-gray-200 pb-4 mb-6 flex items-start justify-between">
        <div>
          <h2 className="text-d font-bold text-primary flex items-center gap-2">
            <HiOutlineDocumentCheck className="w-6 h-6 text-green-600" />
            Plant Head Approval
          </h2>
          <p className="text-tertiary text-sm mt-1">Final review of the incident investigation and proposed corrective actions.</p>
        </div>
        <div className={`px-3 py-1   rounded-md text-[12px] font-semibold border ${isApproved ? 'bg-green-50 text-green-800 border-green-200' : 'bg-yellow-50 text-yellow-800 border-yellow-200'}`}>
          Status: {isApproved ? 'Approved by Plant Head' : 'Pending Plant Head Approval'}
        </div>
      </div>

      <div className="space-y-8">

        {/* Summary of Investigation */}
        <div className="bg-page-bg p-4 rounded-xl border border-gray-200">
          <h3 className="font-semibold text-md text-primary mb-4 border-b border-gray-200 pb-2">Investigation Summary</h3>
          <div className="space-y-4">
            <div>
              <span className="block text-sm font-semibold text-tertiary uppercase tracking-wide">Primary RCA / Contributing Cause</span>
              <p className="mt-1 text-[12px] text-primary">
                {incidentData.investigation?.contributingCause || "Failure of procedural compliance and lack of hazard awareness."}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <span className="block text-sm font-semibold text-tertiary uppercase tracking-wide">Unsafe Act(s)</span>
                <p className="mt-1 text-[12px] text-primary line-clamp-2">
                  {incidentData.investigation?.unsafeAct || "None identified."}
                </p>
              </div>
              <div>
                <span className="block text-sm font-semibold text-tertiary uppercase tracking-wide">Unsafe Condition(s)</span>
                <p className="mt-1 text-[12px] text-primary line-clamp-2">
                  {incidentData.investigation?.unsafeCondition || "Slippery floor."}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Summary of CAPA */}
        <div>
          <h3 className="font-semibold text-md text-primary mb-3 border-b border-gray-200 pb-2">Proposed CAPA ({incidentData.recommendations?.length || 0})</h3>

          {(incidentData.recommendations?.length || 0) === 0 ? (
            <p className="text-sm text-tertiary italic">No recommendations provided.</p>
          ) : (
            <ul className="space-y-3">
              {incidentData.recommendations.map((rec, idx) => (
                <li key={idx} className="flex justify-between items-center p-3 border border-gray-200 rounded-lg text-base bg-card">
                  <span className="font-medium text-primary">{rec.action}</span>
                  <div className="flex gap-4 text-tertiary text-base">
                    <span>Target: {new Date(rec.dueDate).toLocaleDateString()}</span>
                    <span>Owner: {rec.assignedTo}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Approval Form */}
        <div className="pt-4 border-t border-gray-200">
          <label className="block text-base font-medium text-secondary mb-2">Plant Head Comments</label>
          <textarea
            rows={4}
            className="w-full rounded-md border p-2 border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
            placeholder="Enter final remarks, conditions of approval, or reasons for rejection..."
            readOnly={readOnly}
            defaultValue={isApproved ? "Investigation reviewed and CAPAs approved. Ensure timely closure." : ""}
          />
        </div>

        {!readOnly && (
          <div className="flex justify-end gap-4">
            <button className="px-4 py-2 bg-card border border-red-300 text-red-700 hover:bg-red-50 font-medium rounded-lg transition-colors flex items-center gap-2 shadow-sm">
              <HiOutlineXCircle className="w-5 h-5" />
              Reject Investigation
            </button>
            <button
              className="px-4 py-2 text-white font-medium rounded-lg transition-colors flex items-center gap-2 shadow-sm"
              style={{ backgroundColor: '#509183' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3d7268'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#509183'}
            >
              <HiOutlineCheckCircle className="w-5 h-5" />
              Approve Investigation & CAPA
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step6_PlantHeadApproval;
